import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import * as HelperFunctions from '../../components/helpers'; 
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
});

class ScheduledCourseList extends Component {

    constructor(props) {
        super(props);
        this.props.getScheduledCourseList();
    }

    handleRowClick(page_type, scheduled_course_id) {
        this.props.history.push(`/scheduled_course/${page_type}/${scheduled_course_id}`);
    }

    timeColumn = (timeValue) => {
        if (timeValue) {
            return moment(timeValue).format('YYYY-MM-DD')
        }
        else {
            return null
        }
    }

    render() {
        const { classes, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type = {"Scheduled Course"}
                        view_type      = {"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                    </div>
                }
                content={
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "Course Name",
                                accessor: "CourseName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.CourseName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Company",
                                accessor: "CompanyName"
                            },
                            {
                                Header: "Start Date",
                                id: "StartDate",
                                accessor: a => this.timeColumn(a.StartDate)
                            },
                            {
                                Header: "End Date",
                                id: "EndDate",
                                accessor: a => this.timeColumn(a.EndDate)
                            },
                            {
                                Header: "Primary Instructor",
                                accessor: "InstructorName"
                            },
                            {
                                Header: "Students",
                                id: 'CourseSizeLimit',
                                accessor: a => a.StudentCount + '/' + a.CourseSizeLimit
                            },
                            {
                                Header: "Actions",
                                maxWidth: 150,
                                Cell: row => (
                                    <div className="flex items-center">
                                        <Tooltip title="Detail">
                                            <IconButton
                                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleRowClick('detail', row.original.company_calendar_course_id);
                                                }}
                                            >
                                                <Icon>library_books</Icon>
                                            </IconButton>
                                        </Tooltip>
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "scheduled_course", "edit") ? null :
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.handleRowClick('edit', row.original.company_calendar_course_id);
                                                    }}
                                                >
                                                    <Icon>border_color</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                )
                            }
                        ]}
                        data={this.props.scheduledCourseList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Courses Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getScheduledCourseList: Actions.getScheduledCourseList,
        setTableSort:           TableActions.setTableSort,
        setTableFilter:         TableActions.setTableFilter,
        setTablePageSize:       TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, tableSort, auth }) {
    return {
        scheduledCourseList: scheduledCourseApp.scheduledCourses.scheduledCourseList,
        table_sort:          tableSort.table_sort,
        table_filter:        tableSort.table_filter,
        table_page_size:     tableSort.table_page_size,
        is_loaded:           tableSort.is_loaded,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduledCourseList)));


// WEBPACK FOOTER //
// src/main/content/scheduled_course/ScheduledCourseList.js